import { useEffect } from 'react';
import { ContactBand } from './features/contact/components/ContactBand';
import { Coverage } from './features/coverage/components/Coverage';
import { Hero } from './features/hero/components/Hero';
import { ResponseChapter } from './features/response/components/ResponseChapter';
import { ServiceIndex } from './features/services/components/ServiceIndex';
import { ActionDock } from './features/site/components/ActionDock';
import { DemoPreviewBanner } from './shared/components/DemoPreviewBanner';
import { JmrSquaredAttribution } from './shared/components/JmrSquaredAttribution';
import { loadGsap } from './shared/lib/gsap';

export function App() {
  useEffect(() => {
    // Web fonts and lazily-decoded images both change layout after first paint,
    // so every pin has to be remeasured once the page has settled — once, not
    // twice. Refreshing on `fonts.ready` and again on `load` re-measured every
    // trigger on a 13000px document two times over, and style and layout was
    // the second largest block of main-thread work in the profile.
    let cancelled = false;

    const fontsSettled = document.fonts?.ready ?? Promise.resolve();
    const pageLoaded =
      document.readyState === 'complete'
        ? Promise.resolve()
        : new Promise<void>((resolve) => {
            window.addEventListener('load', () => resolve(), { once: true });
          });

    void Promise.all([fontsSettled, pageLoaded]).then(() => {
      if (cancelled) {
        return;
      }

      void loadGsap().then(({ ScrollTrigger }) => ScrollTrigger.refresh());
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex min-h-[100dvh] flex-col bg-[color:var(--color-surface)]">
      <DemoPreviewBanner />

      <main className="flex-1">
        <Hero />
        <ServiceIndex />
        <ResponseChapter />
        <Coverage />
        <ContactBand />
      </main>

      <JmrSquaredAttribution />
      <ActionDock />
    </div>
  );
}
